import React from 'react';
import PropTypes from 'prop-types';
import Result from '../result/result';
import NoData from '../../../components/react/no_data/no_data';
import PaginationInfo from '../../../components/react/pagination_info/pagination_info';
import Pagination from '../../../components/react/pagination/pagination';
import { DEFAULT_PAGE_SIZE } from '../../constants/organization_search.constants';

const Results = ({ data, isLoading, pageNumber, setPageNumber, maxPages, total }) => {
  /**
   * @param {number} newPageNumber - Number of incoming selected page
   * @returns {undefined}
   */
  const onPageSelected = (newPageNumber) => {
    window.scrollTo({
      top: document.getElementById('results').offsetTop,
      behavior: 'smooth',
    });

    setPageNumber(newPageNumber);
  };

  return (
    <div id='results' className='col-xs-12 col-lg-8 pt-35'>
      <div className='clearfix'>
        <div className='float-start mb-15'>
          <PaginationInfo
            resultType='results'
            page={{
              number: pageNumber,
              size: DEFAULT_PAGE_SIZE,
            }}
            total={total}
            loading={isLoading}
          />
        </div>
      </div>
      {data.length ? (
        <ul>
          {data.map((org) => (
            <Result key={org.id} org={org} />
          ))}
        </ul>
      ) : (
        <div data-testid='no organization results'>
          <NoData large className='mb-48' textDescription='No results' />
        </div>
      )}
      <div className='float-end me-15 me-sm-0'>
        <Pagination
          disabled={isLoading}
          currentPage={pageNumber}
          maxPages={maxPages}
          handlePageSelected={onPageSelected}
        />
      </div>
    </div>
  );
};

Results.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pageNumber: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired,
  maxPages: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default Results;
